import { motion } from "framer-motion";
import { Check } from "lucide-react";
import SectionHead from "../SectionHead";

const TYPES = [
    "Prototype quantities",
    "Development batches",
    "Small-volume production",
    "Regular batch production",
    "Repetitive production requirements",
    "Customized components",
];

const DETAILS = [
    { label: "Monthly Installed Capacity", value: "on_request" },
    { label: "Maximum Component Size", value: "on_request" },
    { label: "Maximum Press Capacity", value: "on_request" },
    { label: "Typical Thickness Range", value: "on_request" },
    {
        label: "Production Lead Time",
        value: "Based on drawing, quantity and tooling requirement",
    },
];

export const Production = () => (
    <section id="production" className="py-24 md:py-32 scroll-mt-20 bg-panel/40 border-y border-zinc-900">
        <div className="shell">
            <SectionHead
                num="08"
                overline="Production Capability"
                title="One piece to repeat batches"
            />

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
                <div className="lg:col-span-5">
                    <div className="border-t border-zinc-800">
                        {TYPES.map((t, i) => (
                            <motion.div
                                key={t}
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true, amount: 0.3 }}
                                transition={{ duration: 0.45, delay: i * 0.06 }}
                                data-testid={`production-type-${i + 1}`}
                                className="group flex items-center gap-4 py-4 border-b border-zinc-800"
                            >
                                <span className="w-6 h-6 border border-safety flex items-center justify-center shrink-0 group-hover:bg-safety transition-colors">
                                    <Check size={13} className="text-safety group-hover:text-charcoal transition-colors" />
                                </span>
                                <span className="text-sm md:text-base text-zinc-200">{t}</span>
                            </motion.div>
                        ))}
                    </div>
                </div>

                <div className="lg:col-span-7">
                    <div className="border border-zinc-800 bg-[#0e0e11]">
                        <div className="px-6 md:px-8 py-4 border-b border-zinc-800 font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                            Production Details
                        </div>
                        <div className="grid sm:grid-cols-2">
                            {DETAILS.map((d, i) => (
                                <motion.div
                                    key={d.label}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, amount: 0.2 }}
                                    transition={{ duration: 0.5, delay: i * 0.07 }}
                                    data-testid={`production-detail-${i + 1}`}
                                    className={`p-6 md:p-8 border-zinc-800 ${
                                        i % 2 === 0 ? "sm:border-r" : ""
                                    } ${i < DETAILS.length - 2 || (DETAILS.length % 2 === 1 && i < DETAILS.length - 1) ? "border-b" : ""} hover:bg-panel transition-colors`}
                                >
                                    <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-3">
                                        {d.label}
                                    </div>
                                    {d.value === "on_request" ? (
                                        <span className="on-request">Shared on request</span>
                                    ) : (
                                        <div className="font-display uppercase font-medium tracking-wide text-zinc-100 text-base md:text-lg leading-snug">
                                            {d.value}
                                        </div>
                                    )}
                                </motion.div>
                            ))}
                        </div>
                    </div>
                    <p className="mt-4 text-xs text-zinc-500 leading-relaxed">
                        Detailed capacity figures are deliberately unpublished —
                        share your requirement and we will confirm capacity,
                        lead time and feasibility for your specific component.
                    </p>
                </div>
            </div>
        </div>
    </section>
);

export default Production;